/**
 * Homepage mobile sticky CTA — Save/% offer bar.
 * Hidden over hero and #buy-bundle; shown on other homepage sections (mobile only).
 */
(function (window, document) {
  'use strict';

  function init(bar) {
    if (!bar || bar.getAttribute('data-hsh-ready') === '1') return;
    bar.setAttribute('data-hsh-ready', '1');

    var heroSel = bar.getAttribute('data-hsh-hero') || '.hero-home';
    var pdpId = (bar.getAttribute('data-hsh-pdp') || 'buy-bundle').replace(/^#/, '');
    var hero = document.querySelector(heroSel);
    var pdp = document.getElementById(pdpId);
    if (!hero || !pdp) {
      bar.hidden = true;
      return;
    }

    var mq = window.matchMedia('(max-width: 749px)');
    var heroInView = true;
    var pdpInView = false;

    function sync() {
      var show = mq.matches && !heroInView && !pdpInView;
      bar.hidden = !show;
      document.documentElement.classList.toggle('hsh-home-sticky-cta-active', show);
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === hero) heroInView = entry.isIntersecting;
          if (entry.target === pdp) pdpInView = entry.isIntersecting;
        });
        sync();
      },
      { threshold: 0, rootMargin: '0px' }
    );

    io.observe(hero);
    io.observe(pdp);

    function onMq() {
      sync();
    }

    if (mq.addEventListener) mq.addEventListener('change', onMq);
    else if (mq.addListener) mq.addListener(onMq);

    sync();

    if (window.HshSmoothScroll && typeof window.HshSmoothScroll.bind === 'function') {
      window.HshSmoothScroll.bind(bar);
    }
  }

  function boot() {
    document.querySelectorAll('[data-hsh-home-sticky-cta]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})(window, document);
